import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#92C0DD',
  gradientStop2 = '#45657D',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '22.43 9.09'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M20.02 4.24001C21.2 8.65001 16.46 18.27 8.04997 17.85C1.03997 17.5 -1.24001 8.0499 2.50999 3.8699C5.18999 0.879897 10.26 0.329975 14.2 0.699975C17.49 0.989975 19.36 1.78001 20.02 4.24001Z"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M24.8398 4.24001C23.6598 8.65001 28.3998 18.27 36.8098 17.85C43.8198 17.5 46.0998 8.0499 42.3498 3.8699C39.6698 0.879897 34.5998 0.329975 30.6598 0.699975C27.3698 0.989975 25.4898 1.78001 24.8398 4.24001Z"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M20.1201 4.78993C20.1201 4.78993 22.4301 3.53993 24.7501 4.78993"
        stroke="#D3D3D3"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16.4404 1.03992C16.4404 1.03992 18.4304 0.819946 22.3204 0.819946C26.2104 0.819946 28.4104 1.03992 28.4104 1.03992"
        stroke="#D3D3D3"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.9902 4.24001C21.1702 8.65001 16.4302 18.27 8.02018 17.85C1.01018 17.5 -1.26979 8.0499 2.48021 3.8699C5.16021 0.879897 10.2302 0.329975 14.1702 0.699975C17.4602 0.989975 19.3302 1.78001 19.9902 4.24001Z"
        stroke="#D3D3D3"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M24.8701 4.24001C23.6901 8.65001 28.4301 18.27 36.8401 17.85C43.8501 17.5 46.1301 8.0499 42.3801 3.8699C39.7001 0.879897 34.6301 0.329975 30.6901 0.699975C27.4001 0.989975 25.5201 1.78001 24.8701 4.24001Z"
        stroke="#D3D3D3"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="10.4568"
          y1="-0.322133"
          x2="10.4568"
          y2="14.2138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="34.3992"
          y1="-0.322133"
          x2="34.3992"
          y2="14.2138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
